/* eslint-disable object-shorthand */
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-locize-backend";
import { locizePlugin } from "locize";
import { initReactI18next } from "react-i18next";

const locizeOptions = {
  projectId: import.meta.env.VITE_LOCIZE_PROJECT_ID,
  apiKey: import.meta.env.VITE_LOCIZE_API_KEY,
  version: import.meta.env.VITE_LOCIZE_VERSION,
};

// add new languages here
const supportedLngs = import.meta.env.VITE_STAGE === "prd" ? ["en"] : ["en", "de", "fr"];

console.log("supportedLngs", supportedLngs);

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(locizePlugin)
  .init({
    // comment out fallback to check if any are un-translated or missing keys & LEAVE IN on prod
    fallbackLng: "en",
    debug: import.meta.env.MODE === "development",
    // namespaces declared here will be loaded on app load as they are used across the site in different areas, specific namespaces are loaded at component level
    ns: ["common", "other", "auth", "regex", "countries", "dashboard", "gigs", "onboarding", "regex", "security", "settings", "songs", "writers", "album"],
    react: {
      useSuspense: true,
      bindI18n: "languageChanged editorSaved",
    },
    backend: locizeOptions,
    supportedLngs: supportedLngs,
    saveMissing: import.meta.env.MODE === "development",
  });

export default i18n;
